import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

import { getStatusForApplication } from "../libs/utilities";

const Applications = (props) => {
  const applications = props.user ? props.user.applications : [];

  // TODO: Style based on status
  const output = () => {
    if(props.isLoginComplete) {
      if(props.userSet) {
        if(applications.length === 0) {
          return (<p>No Applications Found</p>)
        } else {
          return (
            <ListGroup>
              {applications.sort((app1, app2) => app1.createdAt - app2.createdAt).map((application) => {
                const applicationPeriod = props.periods.find(period => period.periodId === application.periodId);
                const applicationStatus = getStatusForApplication(application, applicationPeriod);
                return (
                    <LinkContainer to={`/application/${application.periodId}`} key={application.periodId}>
                      <ListGroupItem>{applicationPeriod.name} - {applicationStatus.text}</ListGroupItem>
                    </LinkContainer>
                  )
                }
              )}
            </ListGroup>
          )
        }
      } else {
        return (<p>Fetching Applications</p>)
      }
    } else {
      return (<p>Not Authenticated</p>)
    }
  };

  return (
  <div>
    <h2>Applications</h2>
    {output()}
  </div>
)};

export default Applications;